<template>
  <div id="dashboard" class="container-fluid px-0 listas-page">
    <section class="ps-lg-4 pe-lg-4 pb-4">
      <div class="listas-formulario">
        <header id="seccionCabecera" class="listas-cabecera">
          <div class="listas-cabecera-fila">
            <p class="listas-title-row">
              <span id="cabeceraDashboard" class="listas-title">{{ tituloLista }}</span>
            </p>
            <button
              type="button"
              class="btn listas-alta-toggle"
              :class="{ abierta: altaAbierta }"
              :aria-expanded="altaAbierta ? 'true' : 'false'"
              aria-controls="listas-alta-panel"
              @click="alternarAlta"
            >
              <span class="fas fa-plus listas-alta-toggle-icono" aria-hidden="true"></span>
              <span class="listas-alta-toggle-textos">
                <span :class="{ 'es-oculto': altaAbierta }" :aria-hidden="altaAbierta ? 'true' : 'false'">Nueva lista</span>
                <span :class="{ 'es-oculto': !altaAbierta }" :aria-hidden="altaAbierta ? 'false' : 'true'">Cerrar</span>
              </span>
            </button>
          </div>
          <p class="listas-lead">Agrupa a quién recibe el aviso de una incidencia.</p>
        </header>

        <div id="listas-alta-panel" class="listas-alta-panel" :class="{ abierta: altaAbierta }">
          <div class="listas-alta-panel-interior">
            <section class="listas-sheet">
              <h2 class="listas-bloque-titulo">Nueva lista</h2>
              <b-form @submit.prevent="crearLista">
                <div class="listas-alta-grid" :class="{'con-origen': showOrigenSelector}">
                  <b-form-group
                    v-if="showOrigenSelector"
                    label="Origen"
                    label-for="listas-origen"
                    class="listas-field"
                  >
                    <b-form-select
                      id="listas-origen"
                      v-model="origen"
                      :options="origenOptions"
                    ></b-form-select>
                  </b-form-group>
                  <b-form-group label="Nombre" label-for="listas-nombre" class="listas-field">
                    <b-form-input
                      id="listas-nombre"
                      v-model="nombreLista"
                      maxlength="255"
                    ></b-form-input>
                  </b-form-group>
                  <div class="listas-alta-accion">
                    <b-button
                      type="submit"
                      variant="primary"
                      class="listas-commit"
                      :disabled="creando || !origen"
                    >
                      Crear lista
                    </b-button>
                  </div>
                </div>
              </b-form>
            </section>
          </div>
        </div>

        <div v-if="showErrorAlert || showSuccessAlert" class="listas-avisos" aria-live="polite">
          <b-alert
            v-if="showErrorAlert"
            show
            variant="danger"
            class="mb-0"
            dismissible
            @dismissed="showErrorAlert = false"
          >
            {{ errorAlertText }}
          </b-alert>
          <b-alert
            v-if="showSuccessAlert"
            show
            variant="success"
            class="mb-0"
            dismissible
            @dismissed="showSuccessAlert = false"
          >
            {{ successAlertText }}
          </b-alert>
        </div>

        <p v-if="cargado && listas.length === 0" class="listas-vacio">
          Todavía no hay listas en este origen. Pulsa Nueva lista para crear la primera.
        </p>

        <article v-for="lista in listas" :key="lista.id" class="listas-sheet listas-roster">
          <header class="listas-roster-head">
            <div class="listas-roster-identidad">
              <b-form class="listas-renombrar" @submit.prevent="renombrarLista(lista)">
                <label class="visually-hidden" :for="'renombrar-' + lista.id">Nombre de la lista</label>
                <b-form-input
                  :id="'renombrar-' + lista.id"
                  v-model="renombres[lista.id].nombre"
                  class="listas-nombre-lista"
                  maxlength="255"
                ></b-form-input>
                <b-button
                  type="submit"
                  variant="primary"
                  class="listas-commit"
                  :disabled="renombres[lista.id].sending"
                >
                  Renombrar
                </b-button>
              </b-form>
              <p class="listas-cuenta">{{ cuenta(lista) }}</p>
            </div>
            <b-button
              type="button"
              variant="outline-danger"
              class="listas-peligro"
              :disabled="renombres[lista.id].borrando"
              @click="borrarLista(lista)"
            >
              Borrar lista
            </b-button>
          </header>

          <div class="listas-tabla-wrap">
            <table class="listas-tabla">
              <thead>
                <tr>
                  <th scope="col">Nombre</th>
                  <th scope="col">Teléfono</th>
                  <th scope="col">Email</th>
                  <th scope="col" class="listas-th-accion">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="lista.destinatarios.length === 0">
                  <td colspan="4" class="listas-nadie">Nadie en esta lista.</td>
                </tr>
                <tr v-for="persona in lista.destinatarios" :key="persona.id">
                  <td data-label="Nombre">
                    <b-form-input
                      :id="'corregir-nombre-' + persona.id"
                      v-model="ediciones[persona.id].nombre"
                      class="listas-quiet"
                      autocomplete="off"
                      aria-label="Nombre"
                    ></b-form-input>
                  </td>
                  <td data-label="Teléfono">
                    <b-form-input
                      :id="'corregir-telefono-' + persona.id"
                      v-model="ediciones[persona.id].telefono"
                      class="listas-quiet"
                      autocomplete="off"
                      aria-label="Teléfono"
                    ></b-form-input>
                  </td>
                  <td data-label="Email">
                    <b-form-input
                      :id="'corregir-email-' + persona.id"
                      v-model="ediciones[persona.id].email"
                      class="listas-quiet"
                      autocomplete="off"
                      aria-label="Email"
                    ></b-form-input>
                  </td>
                  <td>
                    <div class="listas-acciones">
                      <b-button
                        type="button"
                        variant="primary"
                        size="sm"
                        class="listas-commit listas-guardar"
                        :disabled="ediciones[persona.id].saving"
                        @click="guardarDestinatario(lista, persona)"
                      >
                        Guardar
                      </b-button>
                      <b-button
                        type="button"
                        variant="outline-danger"
                        size="sm"
                        class="listas-peligro listas-quitar"
                        :disabled="ediciones[persona.id].removing"
                        @click="quitarDestinatario(lista, persona)"
                      >
                        Quitar
                      </b-button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <b-form class="listas-anadir" @submit.prevent="darDeAlta(lista)">
            <p class="listas-anadir-titulo">Añadir persona</p>
            <div class="listas-anadir-grid">
              <b-form-group label="Nombre" :label-for="'alta-nombre-' + lista.id" class="listas-field">
                <b-form-input
                  :id="'alta-nombre-' + lista.id"
                  v-model="borradores[lista.id].nombre"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Teléfono" :label-for="'alta-telefono-' + lista.id" class="listas-field">
                <b-form-input
                  :id="'alta-telefono-' + lista.id"
                  v-model="borradores[lista.id].telefono"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Email" :label-for="'alta-email-' + lista.id" class="listas-field">
                <b-form-input
                  :id="'alta-email-' + lista.id"
                  v-model="borradores[lista.id].email"
                ></b-form-input>
              </b-form-group>
              <div class="listas-anadir-accion">
                <b-button
                  type="submit"
                  variant="primary"
                  class="listas-commit"
                  :disabled="borradores[lista.id].sending"
                >
                  Dar de alta
                </b-button>
              </div>
            </div>
          </b-form>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import auth from '../auth.js';
import {
  defaultEnvioSmsOrigen,
  shouldShowEnvioSmsOrigenSelector,
} from '../envioSmsPermisos.js';
import {envioJsonHeaders} from '../envioJsonHeaders.js';

const GENERIC_ERROR_ALERT_TEXT = 'Ocurrió un error.';

function borradorVacio() {
  return {nombre: '', telefono: '', email: '', sending: false};
}

function edicionDe(persona) {
  return {
    nombre: persona.nombre || '',
    telefono: persona.telefono || '',
    email: persona.email || '',
    saving: false,
    removing: false,
  };
}

export default {
  name: 'ListasDestinatarios',
  data() {
    return {
      effectiveOrigenes: [],
      origen: '',
      nombreLista: '',
      listas: [],
      borradores: {},
      renombres: {},
      ediciones: {},
      cargado: false,
      creando: false,
      altaAbierta: false,
      showSuccessAlert: false,
      showErrorAlert: false,
      successAlertText: '',
      errorAlertText: '',
    };
  },
  computed: {
    tituloLista() {
      if (!this.origen) return 'Lista destinatarios';
      return 'Lista destinatarios ' + this.origen;
    },
    showOrigenSelector() {
      return shouldShowEnvioSmsOrigenSelector(this.effectiveOrigenes);
    },
    origenOptions() {
      return this.effectiveOrigenes.map((value) => ({value, text: value}));
    },
  },
  watch: {
    origen(origen) {
      this.cargarListas(origen);
    },
  },
  created() {
    this.$store.state.botonEditar = false;
    this.$store.state.editar = false;
    this.cargarPermisosOrigen();
  },
  methods: {
    alternarAlta() {
      this.altaAbierta = !this.altaAbierta;
      if (!this.altaAbierta) return;
      this.$nextTick(() => {
        const nombre = document.getElementById('listas-nombre');
        if (nombre) nombre.focus({preventScroll: true});
      });
    },
    cuenta(lista) {
      const total = lista.destinatarios.length;
      if (total === 0) return 'Sin personas';
      if (total === 1) return '1 persona';
      return total + ' personas';
    },
    borrador(listaId) {
      return this.borradores[listaId] || borradorVacio();
    },
    asegurarBorradores(listas) {
      const next = {};
      const renombres = {};
      const ediciones = {};
      for (const lista of listas) {
        next[lista.id] = this.borradores[lista.id] || borradorVacio();
        renombres[lista.id] = {
          nombre: lista.nombre,
          sending: false,
          borrando: false,
        };
        for (const persona of lista.destinatarios) {
          ediciones[persona.id] = edicionDe(persona);
        }
      }
      this.borradores = next;
      this.renombres = renombres;
      this.ediciones = ediciones;
    },
    avisoError(text) {
      this.successAlertText = '';
      this.showSuccessAlert = false;
      this.errorAlertText = text || GENERIC_ERROR_ALERT_TEXT;
      this.showErrorAlert = true;
    },
    avisoOk(text) {
      this.errorAlertText = '';
      this.showErrorAlert = false;
      this.successAlertText = text;
      this.showSuccessAlert = true;
    },
    async leerMensaje(response) {
      try {
        const data = await response.json();
        return data && data.message;
      } catch (_err) {
        return '';
      }
    },
    async cargarPermisosOrigen() {
      try {
        const response = await fetch('api/permisos', {
          method: 'GET',
          headers: auth.getAuthHeader(),
        });
        const data = await response.json();
        this.effectiveOrigenes = (data[0] && data[0].origenesListas) || [];
        this.origen = defaultEnvioSmsOrigen(this.effectiveOrigenes) || '';
      } catch (error) {
        console.error('Error al comprobar Permiso de Origen', error);
      }
    },
    async cargarListas(origen) {
      if (!origen) {
        this.listas = [];
        this.cargado = false;
        return;
      }
      try {
        const response = await fetch(
          'api/envio-sms/listas/gestion?origen=' + encodeURIComponent(origen),
          {method: 'GET', headers: auth.getAuthHeader()},
        );
        if (!response.ok) {
          this.listas = [];
          this.avisoError(await this.leerMensaje(response));
          return;
        }
        const data = await response.json();
        if (this.origen !== origen) return;
        const listas = data.listas || [];
        this.asegurarBorradores(listas);
        this.listas = listas;
        this.cargado = true;
      } catch (error) {
        console.error('Error al cargar Listas destinatarios', error);
        this.listas = [];
        this.avisoError(GENERIC_ERROR_ALERT_TEXT);
      }
    },
    async crearLista() {
      if (this.creando || !this.origen) return;
      this.creando = true;
      try {
        const response = await fetch('api/envio-sms/listas', {
          method: 'POST',
          headers: envioJsonHeaders(auth.getAuthHeader()),
          body: JSON.stringify({
            nombre: this.nombreLista,
            origen: this.origen,
          }),
        });
        if (!response.ok) {
          this.avisoError(await this.leerMensaje(response));
          return;
        }
        this.nombreLista = '';
        this.altaAbierta = false;
        this.avisoOk('Lista creada');
        await this.cargarListas(this.origen);
      } catch (error) {
        console.error('Error al crear Lista destinatarios', error);
        this.avisoError(GENERIC_ERROR_ALERT_TEXT);
      } finally {
        this.creando = false;
      }
    },
    async darDeAlta(lista) {
      const draft = this.borrador(lista.id);
      if (draft.sending) return;
      draft.sending = true;
      try {
        const response = await fetch(
          'api/envio-sms/listas/' + encodeURIComponent(lista.id) + '/destinatarios',
          {
            method: 'POST',
            headers: envioJsonHeaders(auth.getAuthHeader()),
            body: JSON.stringify({
              nombre: draft.nombre,
              telefono: draft.telefono,
              email: draft.email,
            }),
          },
        );
        if (!response.ok) {
          this.avisoError(await this.leerMensaje(response));
          return;
        }
        draft.nombre = '';
        draft.telefono = '';
        draft.email = '';
        this.avisoOk('Destinatario dado de alta');
        await this.cargarListas(this.origen);
      } catch (error) {
        console.error('Error al dar de alta Destinatario', error);
        this.avisoError(GENERIC_ERROR_ALERT_TEXT);
      } finally {
        draft.sending = false;
      }
    },
    async renombrarLista(lista) {
      const draft = this.renombres[lista.id];
      if (!draft || draft.sending) return;
      draft.sending = true;
      try {
        const response = await fetch(
          'api/envio-sms/listas/' + encodeURIComponent(lista.id),
          {
            method: 'PATCH',
            headers: envioJsonHeaders(auth.getAuthHeader()),
            body: JSON.stringify({nombre: draft.nombre}),
          },
        );
        if (!response.ok) {
          this.avisoError(await this.leerMensaje(response));
          return;
        }
        this.avisoOk('Lista renombrada');
        await this.cargarListas(this.origen);
      } catch (error) {
        console.error('Error al renombrar Lista destinatarios', error);
        this.avisoError(GENERIC_ERROR_ALERT_TEXT);
      } finally {
        if (this.renombres[lista.id]) {
          this.renombres[lista.id].sending = false;
        }
      }
    },
    async borrarLista(lista) {
      const draft = this.renombres[lista.id];
      if (!draft || draft.borrando) return;
      draft.borrando = true;
      try {
        const response = await fetch(
          'api/envio-sms/listas/' + encodeURIComponent(lista.id),
          {method: 'DELETE', headers: auth.getAuthHeader()},
        );
        if (!response.ok) {
          this.avisoError(await this.leerMensaje(response));
          return;
        }
        this.avisoOk('Lista borrada');
        await this.cargarListas(this.origen);
      } catch (error) {
        console.error('Error al borrar Lista destinatarios', error);
        this.avisoError(GENERIC_ERROR_ALERT_TEXT);
      } finally {
        if (this.renombres[lista.id]) {
          this.renombres[lista.id].borrando = false;
        }
      }
    },
    async guardarDestinatario(lista, persona) {
      const draft = this.ediciones[persona.id];
      if (!draft || draft.saving) return;
      draft.saving = true;
      try {
        const response = await fetch(
          'api/envio-sms/listas/' + encodeURIComponent(lista.id)
            + '/destinatarios/' + encodeURIComponent(persona.id),
          {
            method: 'PATCH',
            headers: envioJsonHeaders(auth.getAuthHeader()),
            body: JSON.stringify({
              nombre: draft.nombre,
              telefono: draft.telefono,
              email: draft.email,
            }),
          },
        );
        if (!response.ok) {
          this.avisoError(await this.leerMensaje(response));
          return;
        }
        this.avisoOk('Destinatario corregido');
        await this.cargarListas(this.origen);
      } catch (error) {
        console.error('Error al corregir Destinatario', error);
        this.avisoError(GENERIC_ERROR_ALERT_TEXT);
      } finally {
        if (this.ediciones[persona.id]) {
          this.ediciones[persona.id].saving = false;
        }
      }
    },
    async quitarDestinatario(lista, persona) {
      const draft = this.ediciones[persona.id];
      if (!draft || draft.removing) return;
      draft.removing = true;
      try {
        const response = await fetch(
          'api/envio-sms/listas/' + encodeURIComponent(lista.id)
            + '/destinatarios/' + encodeURIComponent(persona.id),
          {method: 'DELETE', headers: auth.getAuthHeader()},
        );
        if (!response.ok) {
          this.avisoError(await this.leerMensaje(response));
          return;
        }
        this.avisoOk('Destinatario quitado');
        await this.cargarListas(this.origen);
      } catch (error) {
        console.error('Error al quitar Destinatario', error);
        this.avisoError(GENERIC_ERROR_ALERT_TEXT);
      } finally {
        if (this.ediciones[persona.id]) {
          this.ediciones[persona.id].removing = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.listas-page {
  --ink: #1b2740;
  --soft: #5c6b86;
  --line: #d5deea;
  --field: #8b97ab;
  --sheet: #f3f6fa;
  --binding: #ff7900;
  --peligro: #9b1c3c;
  margin-top: -0.75rem;
  padding-top: 1.15rem;
  background: #fff;
  color: var(--ink);
}

.listas-formulario {
  max-width: 72rem;
  margin-left: auto;
  margin-right: auto;
}

.listas-cabecera {
  margin-bottom: 1.15rem;
}

.listas-cabecera-fila {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem 1.25rem;
  margin-top: 1rem;
}

.listas-formulario #seccionCabecera .listas-title-row {
  margin-top: 0;
}

/* Las dos etiquetas comparten celda: el botón mide siempre lo que la más larga. */
.listas-alta-toggle-textos {
  display: inline-grid;
}

.listas-alta-toggle-textos > span {
  grid-area: 1 / 1;
  text-align: center;
}

.listas-alta-toggle-textos > .es-oculto {
  visibility: hidden;
}

.listas-formulario .listas-alta-toggle {
  flex: 0 0 auto;
  margin-top: -0.15rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.9rem;
  border: 1px solid var(--ink);
  border-radius: 4px;
  background: var(--ink);
  color: #fff;
  font-weight: 600;
  white-space: nowrap;
  transition: background-color 0.16s ease, color 0.16s ease;
}

.listas-formulario .listas-alta-toggle:hover {
  background: #121a2c;
  border-color: #121a2c;
  color: #fff;
}

.listas-formulario .listas-alta-toggle.abierta {
  background: #fff;
  color: var(--ink);
}

.listas-formulario .listas-alta-toggle.abierta:hover {
  background: var(--sheet);
  border-color: var(--ink);
  color: var(--ink);
}

.listas-alta-toggle-icono {
  font-size: 0.8rem;
  transition: transform 0.2s ease;
}

.listas-alta-toggle.abierta .listas-alta-toggle-icono {
  transform: rotate(45deg);
}

/* Cerrado, el panel no ocupa sitio ni entra en el orden de tabulación. */
.listas-alta-panel {
  display: grid;
  grid-template-rows: 0fr;
  visibility: hidden;
  transition: grid-template-rows 0.25s ease, visibility 0s linear 0.25s;
}

.listas-alta-panel.abierta {
  grid-template-rows: 1fr;
  visibility: visible;
  transition: grid-template-rows 0.25s ease, visibility 0s;
}

.listas-alta-panel-interior {
  min-height: 0;
  overflow: hidden;
}

.listas-alta-panel .listas-sheet {
  margin-bottom: 0.4rem;
}

.listas-formulario #seccionCabecera p {
  text-align: left;
  padding-left: 0;
  margin-bottom: 0;
}

.listas-title {
  display: block;
  font-size: 2rem;
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.05;
  color: var(--ink);
}

.listas-title::after {
  content: "";
  display: block;
  width: 2.25rem;
  height: 3px;
  margin-top: 0.55rem;
  background: var(--binding);
}

.listas-lead {
  margin-top: 0.55rem;
  color: var(--soft);
  font-size: 0.95rem;
}

.listas-sheet {
  background: var(--sheet);
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 1.1rem 1.2rem 1.05rem;
}

.listas-roster {
  margin-top: 0.85rem;
}

.listas-bloque-titulo,
.listas-anadir-titulo {
  margin: 0 0 0.7rem;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--ink);
}

.listas-alta-grid,
.listas-anadir-grid {
  display: grid;
  gap: 0.75rem 1rem;
  align-items: end;
}

.listas-alta-grid {
  grid-template-columns: minmax(0, 1fr) auto;
}

.listas-alta-grid.con-origen {
  grid-template-columns: minmax(11rem, 16rem) minmax(0, 1fr) auto;
}

.listas-anadir-grid {
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.85fr) minmax(0, 1.25fr) auto;
}

.listas-field {
  margin-bottom: 0;
  min-width: 0;
}

.listas-formulario :deep(.form-label) {
  margin-bottom: 0.3rem;
  color: var(--ink);
  font-size: 0.82rem;
  font-weight: 600;
}

.listas-formulario :deep(.form-control),
.listas-formulario :deep(.form-select) {
  border-color: var(--field);
  border-radius: 4px;
  color: var(--ink);
}

.listas-formulario :deep(.form-control:focus),
.listas-formulario :deep(.form-select:focus) {
  border-color: var(--ink);
  box-shadow: 0 0 0 3px rgba(27, 39, 64, 0.14);
}

.listas-avisos {
  margin-top: 0.85rem;
}

.listas-formulario :deep(.alert) {
  border-radius: 4px;
  font-size: 0.9rem;
}

.listas-vacio {
  margin: 0.9rem 0 0;
  color: var(--soft);
  font-size: 0.95rem;
}

.listas-roster-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem 1.25rem;
  margin-bottom: 0.85rem;
}

.listas-roster-identidad {
  flex: 1 1 auto;
  min-width: 0;
}

.listas-renombrar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem 0.65rem;
}

.listas-formulario :deep(.listas-nombre-lista.form-control) {
  flex: 0 1 auto;
  width: auto;
  min-width: 8rem;
  max-width: 100%;
  field-sizing: content;
  height: auto;
  padding: 0.1rem 0.35rem 0.2rem 0;
  border: 0;
  border-bottom: 1px solid transparent;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  font-size: 1.55rem;
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.15;
  color: var(--ink);
}

.listas-formulario :deep(.listas-nombre-lista.form-control:hover) {
  border-bottom-color: var(--line);
}

.listas-formulario :deep(.listas-nombre-lista.form-control:focus) {
  border-bottom-color: var(--ink);
  background: transparent;
  box-shadow: none;
  outline: 2px solid var(--ink);
  outline-offset: 3px;
}

.listas-cuenta {
  margin: 0.2rem 0 0;
  color: var(--soft);
  font-size: 0.8rem;
}

.listas-tabla-wrap {
  overflow-x: auto;
}

.listas-tabla {
  width: 100%;
  border-collapse: collapse;
}

.listas-tabla th {
  padding: 0 0.4rem 0.4rem;
  border-bottom: 1px solid var(--line);
  color: var(--soft);
  font-size: 0.75rem;
  font-weight: 600;
  text-align: left;
}

.listas-tabla th.listas-th-accion {
  text-align: right;
  white-space: nowrap;
}

.listas-tabla td {
  padding: 0.45rem 0.4rem 0.2rem;
  vertical-align: bottom;
  border: 0;
}

.listas-nadie {
  padding: 0.85rem 0.4rem;
  color: var(--soft);
  font-size: 0.9rem;
}

.listas-formulario :deep(.listas-quiet.form-control) {
  border-width: 0 0 2px;
  border-style: solid;
  border-color: var(--field);
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
}

.listas-formulario :deep(.listas-quiet.form-control:hover) {
  border-bottom-color: var(--ink);
  background: transparent;
}

.listas-formulario :deep(.listas-quiet.form-control:focus) {
  border-bottom-color: var(--ink);
  background: #fff;
  box-shadow: none;
  outline: none;
}

.listas-formulario :deep(.listas-quiet.form-control:-webkit-autofill),
.listas-formulario :deep(.listas-quiet.form-control:-webkit-autofill:hover) {
  -webkit-text-fill-color: var(--ink);
  caret-color: var(--ink);
  box-shadow: 0 0 0 1000px #fff inset;
  transition: background-color 9999s ease-out;
}

.listas-acciones {
  display: flex;
  gap: 0.4rem;
  justify-content: flex-end;
}

.listas-anadir {
  margin-top: 0.95rem;
  padding-top: 0.9rem;
  border-top: 1px solid var(--line);
}

.listas-formulario :deep(.listas-commit.btn) {
  background: var(--ink);
  border-color: var(--ink);
  border-radius: 4px;
  color: #fff;
  font-weight: 600;
}

.listas-formulario :deep(.listas-commit.btn:hover:not(:disabled)) {
  background: #121a2c;
  border-color: #121a2c;
  color: #fff;
}

.listas-formulario :deep(.listas-commit.btn:disabled) {
  background: #c5cedb;
  border-color: #c5cedb;
  color: #fff;
  opacity: 1;
}

.listas-formulario :deep(.listas-peligro.btn) {
  background: transparent;
  border-color: #e2c9d1;
  border-radius: 4px;
  color: var(--peligro);
  font-weight: 600;
}

.listas-formulario :deep(.listas-peligro.btn:hover:not(:disabled)) {
  background: var(--peligro);
  border-color: var(--peligro);
  color: #fff;
}

.listas-formulario :deep(.listas-peligro.btn:disabled) {
  color: #c4a8b2;
  border-color: #eadde1;
  background: transparent;
  opacity: 1;
}

.listas-formulario :deep(.listas-guardar.btn) {
  background: transparent;
  border-color: #c5cedb;
  color: var(--ink);
}

.listas-formulario :deep(.listas-guardar.btn:hover:not(:disabled)) {
  background: var(--ink);
  border-color: var(--ink);
  color: #fff;
}

.listas-formulario :deep(.listas-quitar.btn) {
  border-color: transparent;
  background: transparent;
}

.listas-formulario :deep(.listas-quitar.btn:hover:not(:disabled)) {
  background: var(--peligro);
  border-color: var(--peligro);
  color: #fff;
}

.listas-formulario :deep(.btn:focus-visible) {
  outline: 2px solid var(--ink);
  outline-offset: 2px;
}

@media (max-width: 760px) {
  .listas-page {
    padding-top: 0.85rem;
    background: #fff;
  }

  .listas-sheet {
    padding: 0.95rem 0.85rem 0.9rem;
  }

  .listas-title {
    font-size: 1.7rem;
  }

  .listas-alta-grid,
  .listas-alta-grid.con-origen,
  .listas-anadir-grid {
    grid-template-columns: 1fr;
  }

  .listas-alta-accion :deep(.btn),
  .listas-anadir-accion :deep(.btn) {
    width: 100%;
  }

  .listas-roster-head {
    flex-direction: column;
  }

  .listas-formulario :deep(.listas-nombre-lista.form-control) {
    font-size: 1.35rem;
  }

  .listas-tabla thead {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .listas-tabla td[data-label]::before {
    content: attr(data-label);
    display: block;
    margin-bottom: 0.15rem;
    color: var(--soft);
    font-size: 0.75rem;
    font-weight: 600;
  }

  .listas-tabla,
  .listas-tabla tbody,
  .listas-tabla tr,
  .listas-tabla td {
    display: block;
    width: 100%;
  }

  .listas-tabla tr {
    padding: 0.35rem 0 0.5rem;
    border-bottom: 1px solid var(--line);
  }

  .listas-tabla td {
    border-bottom: 0;
    padding: 0.2rem 0;
  }

  .listas-acciones {
    justify-content: flex-start;
    padding-top: 0.35rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .listas-alta-panel,
  .listas-alta-panel.abierta,
  .listas-alta-toggle,
  .listas-alta-toggle-icono,
  .listas-formulario :deep(.form-control),
  .listas-formulario :deep(.btn) {
    transition: none;
  }
}
</style>
